<template>
  <div class="element html-element">
    <label v-if="label" :for="name" :class="labelClass">
      {{ label }}
      <span v-if="validate">*</span>
    </label>
    <div v-if="!hideAssetIcons" class="asset-icons">
      <span class="text">Add Image or Video</span>
      <span class="icon" @click="browse('IMAGE')">
        <icon icon="image" />
      </span>
      <span class="icon" @click="browse('VIDEO')">
        <icon icon="video-circle" />
      </span>
    </div>
    <TinymceEditor ref="editor" :init="settings" v-model="input" :disabled="disabled" />
    <textarea
      ref="input"
      v-model="input"
      v-validate.disable="validate"
      :data-vv-as="validateAs"
      :name="name"
      :id="id"
      :disabled="disabled"
      class="d-none"
    />
    <div v-if="errorText" class="invalid-feedback" v-html="errorText"></div>
    <div
      v-else
      v-for="(error, i) in errors.collect(name)"
      :key="i"
      class="invalid-feedback"
    >{{ error }}</div>
    <small v-if="helpText" class="form-text text-muted" v-html="helpText"></small>
  </div>
</template>

<script>
import TinymceEditor from "@tinymce/tinymce-vue";
import InputFieldProps from "mixins/InputFieldProps";
import AssetBrowser from "./AssetBrowser";

export default {
  inject: ["$validator"],
  mixins: [InputFieldProps],
  components: { TinymceEditor, AssetBrowser },
  props: {
    value: { required: true },
    options: { type: Object, default: () => {} },
    hideAssetIcons: { type: Boolean, default: false }
  },
  data: function() {
    return {
      input: null,
      defaultSettings: {
        min_height: 300,
        resize: true,
        convert_urls: false,
        relative_urls: false,
        plugins: ["code", "fullscreen", "link", "lists", "paste", "table"],
        menubar: "edit insert view format table tools",
        toolbar:
          "ibold italc | bullist numlist indent outdent | alignleft aligncenter alignright alignjustify | link unlink | undo redo removeformat",
        mobile: {
          theme: "mobile",
          plugins: ["fullscreen", "link", "lists", "paste", "table"],
          menubar: "edit insert format table",
          toolbar: "bold italic | bullist numlist indent outdent | fullscreen"
        },
        extended_valid_elements:
          "video[src|width|height|style|controls|controlslist|oncontextmenu]"
      }
    };
  },
  computed: {
    settings() {
      return _.merge(this.defaultSettings, this.options);
    }
  },
  watch: {
    value(val) {
      this.input = val;
    },
    input(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    browse(type) {
      this.$modal(AssetBrowser, { types: [type] })
        .then(selected => this.insert(type, selected))
        .catch(() => {});
    },
    insert(type, asset) {
      var html = "";
      if (type == "IMAGE") {
        html = `<img src="${asset.url}" alt="${asset.name}" />`;
      } else if (type == "VIDEO") {
        html = `<div class="row"><div class="col-12 text-center my-4">`;
        html += `<video src="${asset.url}" style="width:640px; height: 360px; max-width:90vw;" `;
        html += `controls="controls" controlslist="nodownload" oncontextmenu="return false;" />`;
        // html += `<source type="video/mp4" src="${asset.url}" />`;
        // html += `<a href="${asset.url}" target="_blank">Watch Video: "${asset.name}"</a>`;
        html += `</div></div>`;
      } else {
        html = `<a href="${asset.url}" target="_blank">${asset.name}</a>`;
      }
      this.$refs.editor.editor.execCommand("mceInsertContent", false, html);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.input = this.value;
    });
  }
};
</script>
